import { IDateRange } from "@app/dashboard/types/innerLayout/reports";
import { formatToISODate } from "@app/dashboard/utils/dateFormats";

export const getFormattedDates = (range: [Date, Date]): IDateRange => {
  const [formattedStartDate, formattedEndDate] = (range as [Date, Date])?.map(
    (date) => formatToISODate(date)
  );

  return { start_date: formattedStartDate, end_date: formattedEndDate };
};